// This file is copied from https://github.com/GetStream/stream-chat-react/blob/master/src/components/MessageList/UnreadMessagesSeparator.tsx
// with some modifications so that we can control the tranlsations (and to match our older stream library version)
// (stream does not currently support all of our langauges - see SOFTWARE-5782)

import { useTranslation } from "react-i18next";
import React, { FunctionComponent } from "react";

export const UNREAD_MESSAGE_SEPARATOR_CLASS =
  "str-chat__unread-messages-separator";

export type UnreadMessagesSeparatorProps = {
  /**
   * Configuration parameter to determine, whether the unread count is to be shown on the component. Enabled by default.
   */
  showCount?: boolean;
  /**
   * The count of unread messages to be displayed if enabled.
   */
  unreadCount?: number;
};

export const CarbonUnreadMessagesSeparator: FunctionComponent<
  UnreadMessagesSeparatorProps
> = ({ showCount = true, unreadCount }: UnreadMessagesSeparatorProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={UNREAD_MESSAGE_SEPARATOR_CLASS}
      data-testid="unread-messages-separator"
    >
      <div className={"str-chat__unread-messages-separator__text"}>
        {unreadCount && showCount
          ? t("components.Chat.unreadMessagesCount", { count: unreadCount })
          : t("components.Chat.unreadMessages")}
      </div>
    </div>
  );
};
